import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Card from '../../components/Card';
import Empty from '../../components/Empty';
import Error from '../../components/Error';
import JobCardContent from '../../components/JobCardContent';
import Loading from '../../components/Loading';
import Search from '../../components/Search';
import { TYPEFORM_URL } from '../../config/consts';
import useJobs from '../../hooks/useJobs';
import Container from '../../layout/container';
import { getActiveLanguageData } from '../../utils/handleLanguage';
import { handleSearchQuery } from '../../utils/handleQueryString';
import classes from './style.module.scss';

export default function Jobs() {
  const [params, setParams] = useState('');
  const { jobs, loading, error } = useJobs(params);
  const { t } = useTranslation();
  const isjobListReady = !loading && !error;
  const isListEmpty = !jobs.length && !error && !loading;

  const handleClickEmpty = () => {
    window.open(TYPEFORM_URL);
  };

  const handleClickLinkedin = (linkedinUrl = '') => {
    window.open(linkedinUrl);
  };

  const handleClickKariyer = (kariyerUrl = '') => {
    window.open(kariyerUrl);
  };

  const handleClickApplyJob = (applyUrl = '') => {
    window.open(applyUrl);
  };

  const handleSearch = ({ title, location, workSchedule }) => {
    const query = handleSearchQuery({ title, location, workSchedule });
    setParams(query);
  };

  return (
    <Container>
      <div className={classes.inlineContainer}>
        <Search onSearch={handleSearch} />
        {loading && <Loading />}
        {error && <Error />}
        {isListEmpty && (
          <Empty
            buttonText={t('job_empty_button')}
            text={t('job_empty_content')}
            onClick={handleClickEmpty}
          />
        )}
        {isjobListReady &&
          jobs.map((job) => (
            <Card key={job?.id} className={classes.card}>
              <Link to={`/jobs/${job?.slug}`} className={classes.link}>
                <JobCardContent
                  title={getActiveLanguageData({
                    tr: job?.titleTR,
                    en: job?.titleEN
                  })}
                  location={job?.location}
                  date={job?.date}
                  team={job?.team}
                  workSchedules={job?.workSchedules}
                  slug={job?.slug}
                  linkedinUrl={job?.linkedinUrl}
                  kariyerUrl={job?.kariyerUrl}
                  applyUrl={job?.applyUrl}
                  onClickLinkedin={handleClickLinkedin}
                  onClickKariyer={handleClickKariyer}
                  onClickApplyJob={handleClickApplyJob}
                />
              </Link>
            </Card>
          ))}
      </div>
    </Container>
  );
}
